import 'css-chunksrc/client/scenes/projectCreationFromModel/projectEdition/styles.scss';export default {
  "form": "_form_mx0g5_1",
  "buttons": "_buttons_mx0g5_11"
};